import { render, staticRenderFns } from "./BundleSwiper.vue?vue&type=template&id=57e360bc&scoped=true"
import script from "./BundleSwiper.vue?vue&type=script&lang=js"
export * from "./BundleSwiper.vue?vue&type=script&lang=js"
import style0 from "./BundleSwiper.vue?vue&type=style&index=0&id=57e360bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e360bc",
  null
  
)

export default component.exports